export type PidStatusFilter = 'all' | 'available' | 'not_available';

export function matchesPidStatusFilter(filter: PidStatusFilter, pid: unknown): boolean {
  if (filter === 'all') return true;
  const hasPid = String(pid ?? '').trim() !== '';
  return filter === 'available' ? hasPid : !hasPid;
}

/** Build a Hasura predicate that treats null and whitespace-only PIDs as missing. */
export function getPidStatusFilterForQuery(
  filter: PidStatusFilter,
): Record<string, unknown> {
  const seatPidAvailable = { tp_vl_production_id: { _regex: '[^[:space:]]' } };
  const eventPidAvailable = { event: { e_vl_production_id: { _regex: '[^[:space:]]' } } };

  if (filter === 'available') {
    return { _or: [seatPidAvailable, eventPidAvailable] };
  }
  if (filter === 'not_available') {
    return {
      _and: [
        {
          _or: [
            { tp_vl_production_id: { _is_null: true } },
            { tp_vl_production_id: { _regex: '^[[:space:]]*$' } },
          ],
        },
        {
          event: {
            _or: [
              { e_vl_production_id: { _is_null: true } },
              { e_vl_production_id: { _regex: '^[[:space:]]*$' } },
            ],
          },
        },
      ],
    };
  }
  return {};
}